import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_COIN_REQUEST = 'coin/FETCH_COIN_REQUEST'
const FETCH_COIN_SUCCESS = 'coin/FETCH_COIN_SUCCESS'
const FETCH_COIN_FAILURE = 'coin/FETCH_COIN_FAILURE'

const FETCH_COIN_PACKAGE_REQUEST = 'coin/FETCH_COIN_PACKAGE_REQUEST'
const FETCH_COIN_PACKAGE_SUCCESS = 'coin/FETCH_COIN_PACKAGE_SUCCESS'
const FETCH_COIN_PACKAGE_FAILURE = 'coin/FETCH_COIN_PACKAGE_FAILURE'

const CREATE_COIN_PACKAGE_REQUEST = 'coin/CREATE_COIN_PACKAGE_REQUEST'
const CREATE_COIN_PACKAGE_SUCCESS = 'coin/CREATE_COIN_PACKAGE_SUCCESS'
const CREATE_COIN_PACKAGE_FAILURE = 'coin/CREATE_COIN_PACKAGE_FAILURE'

const UPDATE_COIN_PACKAGE_REQUEST = 'coin/UPDATE_COIN_PACKAGE_REQUEST'
const UPDATE_COIN_PACKAGE_SUCCESS = 'coin/UPDATE_COIN_PACKAGE_SUCCESS'
const UPDATE_COIN_PACKAGE_FAILURE = 'coin/UPDATE_COIN_PACKAGE_FAILURE'

const DELETE_COIN_PACKAGE_REQUEST = 'coin/DELETE_COIN_PACKAGE_REQUEST'
const DELETE_COIN_PACKAGE_SUCCESS = 'coin/DELETE_COIN_PACKAGE_SUCCESS'
const DELETE_COIN_PACKAGE_FAILURE = 'coin/DELETE_COIN_PACKAGE_FAILURE'

const FETCH_COIN_PACKAGE_TRANSACTION_REQUEST = 'coin/FETCH_COIN_PACKAGE_TRANSACTION_REQUEST'
const FETCH_COIN_PACKAGE_TRANSACTION_SUCCESS = 'coin/FETCH_COIN_PACKAGE_TRANSACTION_SUCCESS'
const FETCH_COIN_PACKAGE_TRANSACTION_FAILURE = 'coin/FETCH_COIN_PACKAGE_TRANSACTION_FAILURE'

const CONFIRM_COIN_TRANSACTION_REQUEST = 'coin/CONFIRM_COIN_TRANSACTION_REQUEST'
const CONFIRM_COIN_TRANSACTION_SUCCESS = 'coin/CONFIRM_COIN_TRANSACTION_SUCCESS'
const CONFIRM_COIN_TRANSACTION_FAILURE = 'coin/CONFIRM_COIN_TRANSACTION_FAILURE'

const FETCH_COIN_CONDITION_REQUEST = 'coin/FETCH_COIN_CONDITION_REQUEST'
const FETCH_COIN_CONDITION_SUCCESS = 'coin/FETCH_COIN_CONDITION_SUCCESS'
const FETCH_COIN_CONDITION_FAILURE = 'coin/FETCH_COIN_CONDITION_FAILURE'

const CREATE_COIN_CONDITION_REQUEST = 'coin/CREATE_COIN_CONDITION_REQUEST'
const CREATE_COIN_CONDITION_SUCCESS = 'coin/CREATE_COIN_CONDITION_SUCCESS'
const CREATE_COIN_CONDITION_FAILURE = 'coin/CREATE_COIN_CONDITION_FAILURE'

const UPDATE_COIN_CONDITION_REQUEST = 'coin/UPDATE_COIN_CONDITION_REQUEST'
const UPDATE_COIN_CONDITION_SUCCESS = 'coin/UPDATE_COIN_CONDITION_SUCCESS'
const UPDATE_COIN_CONDITION_FAILURE = 'coin/UPDATE_COIN_CONDITION_FAILURE'

const DELETE_COIN_CONDITION_REQUEST = 'coin/DELETE_COIN_CONDITION_REQUEST'
const DELETE_COIN_CONDITION_SUCCESS = 'coin/DELETE_COIN_CONDITION_SUCCESS'
const DELETE_COIN_CONDITION_FAILURE = 'coin/DELETE_COIN_CONDITION_FAILURE'

const FETCH_TRANSACTION_REQUEST = 'coin/FETCH_TRANSACTION_REQUEST'
const FETCH_TRANSACTION_SUCCESS = 'coin/FETCH_TRANSACTION_SUCCESS'
const FETCH_TRANSACTION_FAILURE = 'coin/FETCH_TRANSACTION_FAILURE'

const UPDATE_COIN_REQUEST = 'coin/UPDATE_COIN_REQUEST'
const UPDATE_COIN_SUCCESS = 'coin/UPDATE_COIN_SUCCESS'
const UPDATE_COIN_FAILURE = 'coin/UPDATE_COIN_FAILURE'

const UPDATE_COIN_ALL_REQUEST = 'coin/UPDATE_COIN_ALL_REQUEST'
const UPDATE_COIN_ALL_SUCCESS = 'coin/UPDATE_COIN_ALL_SUCCESS'
const UPDATE_COIN_ALL_FAILURE = 'coin/UPDATE_COIN_ALL_FAILURE'

const FETCH_COIN_USED_REQUEST = 'coin/FETCH_COIN_USED_REQUEST'
const FETCH_COIN_USED_SUCCESS = 'coin/FETCH_COIN_USED_SUCCESS'
const FETCH_COIN_USED_FAILURE = 'coin/FETCH_COIN_USED_FAILURE'

const UPDATE_COIN_USED_REQUEST = 'coin/UPDATE_COIN_USED_REQUEST'
const UPDATE_COIN_USED_SUCCESS = 'coin/UPDATE_COIN_USED_SUCCESS'
const UPDATE_COIN_USED_FAILURE = 'coin/UPDATE_COIN_USED_FAILURE'

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  coin: [],
  coinPackage: [],
  coinCondition: [],
  coinUsed: [],
  coinPackageTransaction: [],
  transaction: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COIN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_COIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coin: action.payload
      }
    case FETCH_COIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_COIN_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_COIN_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coinPackage: action.payload
      }
    case FETCH_COIN_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_COIN_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_COIN_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coinCondition: action.payload
      }
    case FETCH_COIN_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_COIN_USED_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case FETCH_COIN_USED_SUCCESS:
        return {
          ...state,
          isLoading: false,
          coinUsed: action.payload
        }
      case FETCH_COIN_USED_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    case FETCH_COIN_PACKAGE_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_COIN_PACKAGE_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coinPackageTransaction: action.payload
      }
    case FETCH_COIN_PACKAGE_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transaction: action.payload
      }
    case FETCH_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_COIN_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_COIN_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_COIN_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_COIN_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_COIN_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_COIN_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_COIN_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_COIN_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_COIN_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_COIN_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_COIN_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_COIN_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_COIN_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_COIN_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_COIN_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_COIN_PACKAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_COIN_PACKAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_COIN_PACKAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CONFIRM_COIN_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CONFIRM_COIN_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CONFIRM_COIN_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_COIN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_COIN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_COIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_COIN_ALL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_COIN_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_COIN_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case UPDATE_COIN_USED_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_COIN_USED_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case UPDATE_COIN_USED_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    default:
      return state
  }
}

// Action Creators
export const fetchCoinByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_REQUEST
      })
      const response = await API.get(EndPoints.HEROPROMOTE + `/getCoin` + `/${id}`)
      dispatch({
        type: FETCH_COIN_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_FAILURE
      })
    }
  }
}

export const fetchCoinPackage = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_PACKAGE_REQUEST
      })
      const response = await API.get(EndPoints.HEROCOIN + `/getAllCoinPackage`)
      dispatch({
        type: FETCH_COIN_PACKAGE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_PACKAGE_FAILURE
      })
    }
  }
}
export const fetchCoinCondition = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_CONDITION_REQUEST
      })
      const response = await API.get(EndPoints.HEROCOIN + `/getAllCondition`)
      dispatch({
        type: FETCH_COIN_CONDITION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_CONDITION_FAILURE
      })
    }
  }
}
export const fetchCoinUsed = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_USED_REQUEST
      })
      const response = await API.get(EndPoints.HEROCOIN + `/getAllCoinUsed`)
      dispatch({
        type: FETCH_COIN_USED_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_USED_FAILURE
      })
    }
  }
}
export const fetchCoinPackageTransaction = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_PACKAGE_TRANSACTION_REQUEST
      })
      const response = await API.get(EndPoints.HEROCOIN + `/getAllTransaction`)
      dispatch({
        type: FETCH_COIN_PACKAGE_TRANSACTION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_PACKAGE_TRANSACTION_FAILURE
      })
    }
  }
}
export const createCoinPackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_COIN_PACKAGE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.HEROCOIN + `/createCoinPackage`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_COIN_PACKAGE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_COIN_PACKAGE_FAILURE
      })
    }
  }
}
export const updateCoinPackage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_PACKAGE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HEROCOIN + `/updateCoinPackage`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_COIN_PACKAGE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_PACKAGE_FAILURE
      })
    }
  }
}
export const deleteCoinPackage = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_COIN_PACKAGE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HEROCOIN + `/deleteCoinPackage` + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_COIN_PACKAGE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_COIN_PACKAGE_FAILURE
      })
    }
  }
}
export const createCoinCondition = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_COIN_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.HEROCOIN + `/createCondition`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_COIN_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_COIN_CONDITION_FAILURE
      })
    }
  }
}
export const updateCoinCondition = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HEROCOIN + `/updateCondition`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_COIN_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_CONDITION_FAILURE
      })
    }
  }
}
export const deleteCoinCondition = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_COIN_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.HEROCOIN + `/deleteCondition` + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_COIN_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_COIN_CONDITION_FAILURE
      })
    }
  }
}
export const confirmCoinTransaction = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CONFIRM_COIN_TRANSACTION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HEROCOIN + `/adminConfirmPayment`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CONFIRM_COIN_TRANSACTION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CONFIRM_COIN_TRANSACTION_FAILURE
      })
    }
  }
}

export const fetchTransectionByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_TRANSACTION_REQUEST
      })
      const response = await API.get(EndPoints.HEROPROMOTE + `/getTransaction` + `/${id}`)
      dispatch({
        type: FETCH_TRANSACTION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_TRANSACTION_FAILURE
      })
    }
  }
}

export const updateCoin = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''

      await API.post(EndPoints.HEROPROMOTE + `/makeTransaction`, data, {
        headers: {
          Authorization: authorizationHeader
        },
      })
      dispatch({
        type: UPDATE_COIN_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_FAILURE
      })
    }
  }
}
export const updateCoinAllHero = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_ALL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''

      await API.post(EndPoints.HEROPROMOTE + `/makeTransactionAllHero`, data, {
        headers: {
          Authorization: authorizationHeader
        },
      })
      dispatch({
        type: UPDATE_COIN_ALL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_ALL_FAILURE
      })
    }
  }
}
export const updateCoinUsed = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_USED_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HEROCOIN + `/updateCoinUsed`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_COIN_USED_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_USED_FAILURE
      })
    }
  }
}


